/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedContactDealerButton_item$ref = any;
export type PdpSharedDescriptionAdditionalOptionsContent_item$ref = any;
export type PdpSharedDescriptionAdditionalOptionsContent_item = {
    readonly " $fragmentRefs": PdpSharedContactDealerButton_item$ref;
    readonly " $refType": PdpSharedDescriptionAdditionalOptionsContent_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDescriptionAdditionalOptionsContent_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactDealerButton_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '1a0a6969f5c52e6dfc9f57f295f15c63';
export default node;
